import { render, staticRenderFns } from "./risk-estimate.vue?vue&type=template&id=2082a036&scoped=true"
import script from "./risk-estimate.vue?vue&type=script&lang=js"
export * from "./risk-estimate.vue?vue&type=script&lang=js"
import style0 from "./risk-estimate.vue?vue&type=style&index=0&id=2082a036&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082a036",
  null
  
)

export default component.exports